import { app } from 'core';
import { useRedirectToHome } from 'ui/hooks/useRedirectToHome';

const useHandleClick = () => {
  const { trackClick } = app.commands.useAppCommand();
  const { redirectToHome } = useRedirectToHome();

  const handleReloadPage = (event: React.UIEvent) => {
    trackClick(event);
    window.location.reload();
  };

  const handleRedirectToHome = (event: React.UIEvent) => {
    trackClick(event);
    redirectToHome();
  };

  const handleTrackClick = (event: React.UIEvent) => {
    trackClick(event);
  };

  return { handleReloadPage, handleRedirectToHome, handleTrackClick };
};

export default useHandleClick;
